import { GetRoamingHoursDto, GetRoamingHoursResp } from "@usecase/roaming/get-roaming-hours/get-roaming-hours.type";
import { GetRoamingPageDataResp } from "@usecase/roaming/get-roaming-page-data/get-roaming-page-data.type";
import { Observable } from "rxjs";

export abstract class RoamingRepository {
    abstract GetRoamingPageData(): Observable<GetRoamingPageDataResp>;
    abstract GetRoamingHours(payload: GetRoamingHoursDto): Observable<GetRoamingHoursResp>
}